import styled from 'styled-components';

import { Spinner } from 'ui/spinner';
import { layoutLRPadding, layoutTopPadding, base } from 'ui/theme/spacing';
import { SelectAdAccountHeader } from './AdAccountHeader';
import { SelectAdAccountForm } from './SelectAdAccountForm';
import { AdAccountConfirmationModal } from '../modals/AdAccountConfirmationModal';
import { useAdAccountContext } from '../../contexts/AdAccountContext';
import { useFacebookLoginContext } from '../../contexts/FacebookLoginContext';
import { NoAdAccountResults } from './NoAdAccountResults';

const StyledContainer = styled.div<{ $isError: boolean }>`
  margin: -${layoutTopPadding} -${layoutLRPadding} calc(-${base} - 1px) -${layoutLRPadding};
  background-color: ${({ $isError }) => ($isError ? '#fff' : '#FAFAFA')};
`;

const AdAccountLoading = styled.div`
  height: ${({ theme }) => theme.spacing.utils.pxToRem(600)};
`;

export const SelectAdAccountPage = () => {
  const { isLoading, allAdAccountIds } = useAdAccountContext();
  const { loginCode } = useFacebookLoginContext();

  const noAdAccountIds = allAdAccountIds.length === 0;
  const hasPageError = !loginCode || noAdAccountIds;

  if (isLoading) {
    return (
      <AdAccountLoading>
        <Spinner />
      </AdAccountLoading>
    );
  }

  return (
    <StyledContainer data-test="select-ad-account-page" $isError={hasPageError}>
      <SelectAdAccountHeader />
      {!hasPageError && <SelectAdAccountForm />}
      {hasPageError && <NoAdAccountResults />}
      <AdAccountConfirmationModal />
    </StyledContainer>
  );
};
